import * as React from "react";
import { IE2ETestableComponent } from "../../../../../e2e/IE2ETestableComponent";
import { Wrapper } from "./Wrapper";

export interface ISettingsContent extends IE2ETestableComponent {
  children?: any;
  active?: boolean;
}

export const SettingsPane = ({
  active = false,
  children,
  dataE2EId
}: ISettingsContent) => {
  return (
    <Wrapper active={active} data-e2e-id={dataE2EId}>
      {children}
    </Wrapper>
  );
};
